import React, { useEffect, useState } from 'react'
import FormCustom from '../../Components/Form/FormCustom';
import Input from '../../Components/Form/Input';
import Helpers from '../../Components/Helpers/Helpers';
import Controllers from '../../Api/Controllers';
import { toast } from 'react-toastify'
import SweetAlert from '../../Components/SweetAlert/SweetAlert';
import Button from 'react-bootstrap/esm/Button';
import { useSelector } from 'react-redux';

const BreakBoxRequestEachHour = ({ requestNow = false }) => {
  const [amount, setAmount] = useState('')
  const [loadSubmit, setLoadSubmit] = useState(false)
  const hour = Helpers.date.get({
    format: '%H'
  })
  const [show, setShow] = useState(false)
  const [showAlert, setShowAlert] = useState(false)

  const store = useSelector(store => store)

  useEffect(() => {
    if (requestNow) {
      setShow(requestNow)
    } else {
      const openBreakBox = setInterval(() => {
        const now = new Date();
        const minutes = now.getMinutes();
        const hour = now.getHours();
        console.log(minutes, hour)

        let last_hour_saved = store.session.last_hour_saved ? new Date(store.session.last_hour_saved) : null
        // console.log(last_hour_saved, last_hour_saved.getHours(), last_hour_saved.getMinutes())

        if (last_hour_saved) {
          if (minutes === 0 && hour !== last_hour_saved.getHours()) {
            clearInterval(openBreakBox)
            setShow(true)
          }
        } else {
          if (minutes === 0) {
            clearInterval(openBreakBox)
            setShow(true)
          }
        }
      }, 1000)
    }
  }, [requestNow, store.session.last_hour_saved])

  const handleInsertUpdate = ({ data }) => {
    setLoadSubmit(true)
    Controllers.users.save_break_box_user(data).then(res => {
      Helpers.toast.construct({ ...res, toast })
      if (res.response === 'success') {
        setShow(false)
        setShowAlert(true)
      }
    }).catch(req => Helpers.promise.catch({ req, toast }))
      .finally(() => {
        setLoadSubmit(false)
      })
  }

  return <>
    {show && <div style={{
      height: '100%',
      width: '100%',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      position: 'fixed',
      zIndex: 9999,
      background: 'rgba(55, 106, 135, 0.5)',
      padding: 20
    }}>
      <div style={{
        padding: 20,
        background: '#E4E7EE',
        borderRadius: 10,
        textAlign: 'center'
      }}>
        <h2 className='font-weight-bold mb-2'>CORTE DE CAJA</h2>

        <div>1. Separa tu fondo de caja contando monedas, puede ser aproximado.</div>
        <div>2. Cuenta el efectivo cerrando cantidades a 50 (850, 900, 950).</div>
        <div>3. El corte es únicamente de efectivo, no de tickets.</div>

        <h2 className="font-weight-bold mt-2">{hour}:00 {hour < 12 ? 'AM' : 'PM'}</h2>

        <FormCustom textButton="Guardar Corte de Caja" dataSubmit={{
          p_amount: amount
        }} onSubmit={handleInsertUpdate} loadSubmit={loadSubmit}>
          <Input
            size="lg"
            text="Cantidad"
            placeholder="Cantidad"
            classNameParent="col-12 mb-2"
            icon="fas fa-sort-numeric-up-alt"
            required
            invalid="El campo es obligatorio."
            type="number"
            min="0"
            step="0.01"
            onChange={e => {
              setAmount(e.currentTarget.value)
            }}
          />
        </FormCustom>
      </div>
    </div>}
    <SweetAlert iconClassName="fa fa-check text-success" show={showAlert} title="Corte de caja guardado correctamente" addCustomButtons customButtons={() => {
      return <>
        <Button variant="primary" onClick={_ => {
          window.location.reload();
        }}>
          OK
        </Button>
      </>
    }} />
  </>
}

export default BreakBoxRequestEachHour